import {createReducer} from "redux-act";
import {IError} from "modules/types";
import {
	hideBadgeModal,
	hideErrorModal,
	hideModal,
	hideSuccessModal,
	openModal,
	showBadgeModal,
	showErrorModal,
	showSuccessModal,
} from "modules/actions";

export interface IModalsReducer {
	error?: string;
	message?: string;
	badgeModalName: string;
	isOpenModals: {
		successChangePassword: boolean;
		changeAvatar: boolean;
		successUpdateProfile: boolean;
		successRecoveryPassword: boolean;
	};
}

const initialState: IModalsReducer = {
	error: "",
	message: "",
	badgeModalName: "",
	isOpenModals: {
		successChangePassword: false,
		changeAvatar: false,
		successUpdateProfile: false,
		successRecoveryPassword: false,
	},
};

export type ModalType = keyof typeof initialState["isOpenModals"];

const onShowErrorModal = (state: IModalsReducer, {message}: IError) => ({
	...state,
	message: "",
	error: message,
});

const onHideErrorModal = () => ({
	...initialState,
});

const onShowSuccessModal = (state: IModalsReducer, message: string) => ({
	...state,
	error: "",
	message,
});

const onHideSuccessModal = (state: IModalsReducer) => ({
	...state,
	message: "",
});

const onShowBadgeModal = (state: IModalsReducer, payload: string) => ({
	...state,
	badgeModalName: payload,
});

const onHideBadgeModal = (state: IModalsReducer) => ({
	...state,
	badgeModalName: "",
});

const onOpenModal = (state: IModalsReducer, payload: ModalType) => ({
	...state,
	isOpenModals: {
		...state.isOpenModals,
		[payload]: true,
	},
});

const onHideModal = (state: IModalsReducer, payload: ModalType) => ({
	...state,
	isOpenModals: {
		...state.isOpenModals,
		[payload]: false,
	},
});

export const modals = createReducer<IModalsReducer>({}, initialState)
	.on(showErrorModal, onShowErrorModal)
	.on(hideErrorModal, onHideErrorModal)
	.on(showSuccessModal, onShowSuccessModal)
	.on(hideSuccessModal, onHideSuccessModal)
	.on(openModal, onOpenModal)
	.on(hideModal, onHideModal)
	.on(showBadgeModal, onShowBadgeModal)
	.on(hideBadgeModal, onHideBadgeModal);
